import service from '@/plugins/request';

// 添加评论
export function apiCommentAdd (params) {
  return service({
    url: '/v1/protected/comment/add',
    method: 'post',
    data: params,
    successToast: true,
    errorToast: true
  });
}

// 评论列表
export function apiCommentList (params) {
  return service({
    url: '/v1/comment/pageList',
    method: 'get',
    params: params
  });
}

// 获取某用户评论列表
export function apiCommentListUid (params) {
  return service({
    url: '/v1/user/commentList',
    method: 'get',
    params: params
  });
}

// 获取对某用户评论列表
export function apiCommentMeList (params) {
  return service({
    url: '/v1/user/commentMeList',
    method: 'get',
    params: params
  });
}

// 删除评论
export function apiCommentDel (params) {
  return service({
    url: '/v1/protected/comment/delete',
    method: 'post',
    data: params,
    successToast: true
  });
}

// 评论置顶
export function apiCommentTop (params) {
  return service({
    url: '/v1/protected/comment/top',
    method: 'post',
    data: params,
  });
}
